import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalKey } from '@frontend-workspace/shared/src/lib/types/modal-key';

@Component({
  selector: 'fip-documents-modal',
  templateUrl: './documents.modal.html',
  styleUrls: ['./documents.modal.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DocumentsModalComponent {
  data = inject<{
    files: {
      url: string;
      fileName: string;
    }[];
  }>(MAT_DIALOG_DATA);

  readonly modalKey: ModalKey = 'documents';
}
